module.exports = __webpack_public_path__ + "img/wbtc.6eaf8be6.svg";